<template>
    <div>
        <v-row justify="center" style="background-color: #0d2155;">
            <v-col cols="0" sm="2"></v-col>
            <v-col cols="12" sm="8">
                <v-container>
                    <div class="my-2 text-h4 font-weight-light" style="color: #ffffff;">
                        <LanguagePlaceholder is-html default-text="My Profile" />
                    </div>
                </v-container>
            </v-col>
            <v-col cols="0" sm="2"></v-col>
        </v-row>
        <v-row justify="center" style="background-color: #0d2155;">
            <v-col cols="0" sm="2"></v-col>
            <v-col cols="12" sm="8">
                <v-container>
                    <v-card color="#cbeeff">
                        <v-card-text class="pa-0">
                            <v-window v-model="optionsWindow">
                                <v-window-item value="detail" class="pa-4">
                                    <v-row>

                                        <v-col class="" cols="12" md="6">
                                            <div>
                                                <div class="text-h6" style="color: #0d2155">{{
                                                    systemStore.userDetail.fullname }}</div>
                                                <div class="text-subtitle-1">{{ systemStore.userDetail.jobDescription }}
                                                </div>
                                            </div>
                                            <br>
                                            <div class="text-subtitle-1 my-2">
                                                <div class="mb-n1">
                                                    <LanguagePlaceholder default-text="Email Address" />
                                                </div>
                                                <div class="font-weight-bold">{{ systemStore.userDetail.emailAddress }}
                                                </div>
                                            </div>
                                            <div class="text-subtitle-1 my-2">
                                                <div class="mb-n1">
                                                    <LanguagePlaceholder default-text="Affinity ID" />
                                                </div>
                                                <div class="font-weight-bold">{{ systemStore.userDetail.affinityId }}
                                                </div>
                                            </div>

                                        </v-col>
                                        <v-col class="" cols="12" md="6">
                                            <!-- <v-btn class="my-2" prepend-icon="mdi-refresh" block color="#0672cb"
                                                @click="optionsWindow = 'resetPassword'">Reset Password</v-btn> -->
                                            <v-btn class="my-2" prepend-icon="mdi-comment-outline" block
                                                @click="optionsWindow = 'changeLanguage'" color="#0672cb">
                                                <LanguagePlaceholder default-text="Change Language" />
                                            </v-btn>
                                            <v-btn class="my-2" prepend-icon="mdi-file-document-multiple-outline" block
                                                @click="showTermsAndConditions = true" color="#0672cb">
                                                <LanguagePlaceholder default-text="View T&Cs" />
                                            </v-btn>
                                            <v-btn class="my-2" prepend-icon="mdi-email-multiple-outline" block
                                                @click="optionsWindow = 'preferredCommunication'" color="#0672cb">
                                                <LanguagePlaceholder default-text="Preferred Communication" />
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-window-item>
                                <v-window-item value="resetPassword">
                                    <v-card>
                                        <v-card-title style="background-color: #0672cb;" class="text-white elevation-1">
                                            <LanguagePlaceholder default-text="Reset Password" />
                                        </v-card-title>
                                        <v-card-text>
                                            <v-container>
                                                <PasswordStrength class="mt-2" v-model="newPassword"
                                                    :min-characters="12" @passwordValidated="passwordValidated"
                                                    inner-icon="mdi-lock-outline" place-holder="Enter your password" />

                                            </v-container>

                                        </v-card-text>
                                        <v-card-actions>
                                            <v-btn class="text-none" @click="optionsWindow = 'detail'" width="100"
                                                variant="tonal">
                                                <LanguagePlaceholder default-text="Cancel" />
                                            </v-btn>

                                            <v-spacer></v-spacer>
                                            <v-btn :disabled="canSaveNewPassword == false" variant="elevated"
                                                @click="optionsWindow = 'detail'" class="text-none" color="#055699"
                                                width="100">
                                                <LanguagePlaceholder default-text="Save" />
                                            </v-btn>

                                        </v-card-actions>
                                    </v-card>
                                </v-window-item>
                                <v-window-item value="changeLanguage">
                                    <v-card>
                                        <v-card-title style="background-color: #0672cb;" class="text-white elevation-1">
                                            <LanguagePlaceholder default-text="Change Language" />
                                        </v-card-title>
                                        <v-card-text>
                                            <v-container>
                                                <v-radio-group v-model="defaultLanguage">
                                                    <v-radio v-for="o in systemStore.getData('languages')"
                                                        :label="o.language" :value="o.language"
                                                        color="#0672cb"></v-radio>
                                                </v-radio-group>
                                            </v-container>
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-btn class="text-none" @click="optionsWindow = 'detail'" width="100"
                                                variant="tonal">
                                                <LanguagePlaceholder default-text="Cancel" />
                                            </v-btn>
                                            <v-spacer></v-spacer>
                                            <v-btn variant="elevated" @click="clickSaveUpdateLanguage" class="text-none"
                                                color="#055699" width="100">
                                                <LanguagePlaceholder default-text="Save" />
                                            </v-btn>

                                        </v-card-actions>
                                    </v-card>
                                </v-window-item>
                                <v-window-item value="preferredCommunication">
                                    <v-card>
                                        <v-card-title style="background-color: #0672cb;" class="text-white elevation-1">
                                            <LanguagePlaceholder default-text="Preferred Communication" />
                                        </v-card-title>
                                        <v-card-text>
                                            <v-container>
                                                <div>
                                                    <p>
                                                        <LanguagePlaceholder
                                                            default-text="As part of your RISE membership, you will receive up to three different types of RISE system generated communications:" />

                                                    </p>
                                                    <br>
                                                    <ol>
                                                        <li>
                                                            <strong>
                                                                <LanguagePlaceholder default-text="Essential:" />
                                                            </strong>
                                                            <LanguagePlaceholder
                                                                default-text="These emails relate to resetting your password and receiving your RISE Rewards. You are not able to opt out of these emails as they are essential to your RISE account." />
                                                        </li>
                                                        <li>
                                                            <strong>
                                                                <LanguagePlaceholder default-text="Notifications:" />
                                                            </strong>
                                                            <LanguagePlaceholder
                                                                default-text="These emails relate to activity on your RISE account. They will let you know when you have reached a reward threshold or remind you to claim your RISE rewards." />
                                                        </li>
                                                        <li>
                                                            <strong>
                                                                <LanguagePlaceholder default-text="Information:" />
                                                            </strong>
                                                            <LanguagePlaceholder
                                                                default-text="These emails relate to general information about how you are performing in RISE. Please note that these are separate to the marketing emails you may receive about RISE." />
                                                        </li>
                                                    </ol>
                                                    <br>
                                                    <p>
                                                        <LanguagePlaceholder
                                                            default-text="Please indicate if you wish to receive RISE notifications and RISE information emails by moving the toggles below. These emails will be sent to the email address you use to log in with. You can revisit this page at any time to change your selection." />

                                                    </p>
                                                    <br>
                                                    <p>
                                                        <LanguagePlaceholder default-text="If you wish to opt in or out of RISE marketing emails, please
                                                        visit the Dell partner portal" />
                                                        <a href="https://www.delltechnologies.com/partner/en-gb/partner/partner.htm"
                                                            target="_blank">
                                                            <LanguagePlaceholder default-text="here" />
                                                        </a>.
                                                    </p>
                                                    <br>
                                                    <v-switch density="compact" color="#0672cb">
                                                        <template v-slot:label>
                                                            <LanguagePlaceholder is-html
                                                                default-text="System generated RISE Notifications" />
                                                        </template>

                                                    </v-switch>
                                                    <v-switch density="compact" color="#0672cb">
                                                        <template v-slot:label>
                                                            <LanguagePlaceholder is-html
                                                                default-text="System generated RISE Information emails" />
                                                        </template>
                                                    </v-switch>
                                                    <br>
                                                    <p>
                                                        <LanguagePlaceholder default-text="When your organization registered to become a Dell Authorized partner, a generic company email address may have been provided. If this was the case, it is listed below. We may use this email to contact your organization about your RISE account, so please check that this email is still valid and is the correct one to use." />
                                                    </p>
                                                    <br>
                                                    <p>
                                                        <LanguagePlaceholder default-text="If you would like to update your default email address please contact us via email to" />
                                                         <a href="mailto:support@dellpartnerincentives.com">support@dellpartnerincentives.com</a>
                                                    </p>
                                                    <br>
                                                    <v-text-field disabled variant="outlined"
                                                        v-model="organizationDefaultEmail"
                                                        >
                                                        <template v-slot:label>                                                            	
                                        <LanguagePlaceholder is-html default-text="Organization default email address" />
                                    </template>

                                                    </v-text-field>
                                                </div>
                                            </v-container>
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-btn class="text-none" @click="optionsWindow = 'detail'" width="100"
                                                variant="tonal"><LanguagePlaceholder default-text="text" />Cancel</v-btn>
                                            <v-spacer></v-spacer>
                                            <v-btn variant="elevated" @click="optionsWindow = 'detail'"
                                                class="text-none" color="#055699" width="100"><LanguagePlaceholder default-text="Save" /></v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-window-item>
                            </v-window>

                        </v-card-text>
                    </v-card>
                </v-container>
            </v-col>
            <v-col cols="0" sm="2"></v-col>
        </v-row>
        <v-row no-gutters="" justify="center" style="background-color: #ffffff;">
            <v-col cols="0" sm="2"></v-col>
            <v-col cols="12" sm="8">
                <v-container>
                    <div class="my-2 text-h4 font-weight-light" style="color: #0d2155;">
                        <LanguagePlaceholder s-html default-text="RISE User Management" />
                    </div>
                    <br>
                    <p>
                        You can manage who in your organization is part of the RISE incentive program. The summary below
                        shows
                        who currently has access to the portal.
                    </p>
                    <br>
                    <p>
                        If anyone listed has left your organization, you can remove their access using the
                        '<strong>Deactivate</strong>' button. They will receive an email letting them know they have
                        been
                        removed.
                    </p>
                    <br>
                    <p>
                        If you have team members who would benefit from the information available, you can add them to
                        RISE
                        using the '<strong>Invite User</strong>' button. They will appear in the list as
                        '<strong>Invited</strong>'
                        until they activate their account. At this point, their status will change to
                        '<strong>Active</strong>'.
                    </p>
                    <br>
                    <p>
                        Anyone listed as '<strong>Not Active</strong>' has not completed the registration process.
                        Contact us at
                        <a href="mailto:support@dellpartnerincentives.com">support@dellpartnerincentives.com</a> if you
                        would
                        like us to re-send their activation code.
                    </p>
                    <br>
                    <p>
                        Anyone listed as '<strong>Active (Accepted T&Cs)</strong>' has successfully activated their
                        account and
                        accepted the RISE portal terms of use. <strong>Please note this is not related to the RISE
                            program terms
                            and conditions and does not determine whether an organization is part of the RISE
                            program.</strong>
                    </p>
                    <br>
                    <p>
                        For support or guidance, please contact us on <a
                            href="mailto:support@dellpartnerincentives.com">support@dellpartnerincentives.com</a>
                    </p>
                    <br>
                    <br>
                    <div class="my-2 text-h4 font-weight-light" style="color: #0d2155;">
                        <LanguagePlaceholder code="elgp-2" is-html default-text="Manage RISE Access" />
                    </div>
                    <br>
                    <p class="general-text">
                        <LanguagePlaceholder default-text="Organization Users" />
                    </p>
                    <v-toolbar density="compact">
                        <v-spacer></v-spacer>
                        <v-btn :disabled="isOrganizationAdmin == false" @click="showSendInvitation = true"><LanguagePlaceholder default-text="Invite User" /></v-btn>
                    </v-toolbar>
                    <v-data-table items-per-page="15" density="compact" :headers="headersOrganizationUsers"
                        :items="organizationUsers" item-key="user">
                        <template v-slot:item.toggleStatus="{ item }">
                            <v-btn v-if="isOrganizationAdmin === true && item.accountStatusLink == 1"
                                @click="clickChangeStatus(item, 'Disable')" variant="tonal" size="small">
                                <LanguagePlaceholder default-text="Disable" /></v-btn>
                            <v-btn v-if="isOrganizationAdmin === true && item.accountStatusLink == 4"
                                @click="clickChangeStatus(item, 'Activate')" variant="tonal"
                                size="small"><LanguagePlaceholder default-text="Activate" /></v-btn>
                        </template>
                    </v-data-table>
                    <br>
                    <br>
                    <p class="general-text">
                        Invitations Sent
                    </p>
                    <v-data-table items-per-page="15" density="compact" :headers="headersInvitations"
                        :items="invitations" item-key="user">
                    </v-data-table>
                    <br>
                    <br>
                    <div class="my-2 text-h4 font-weight-light" style="color: #0d2155;">
                        <LanguagePlaceholder code="elgp-2" is-html default-text="Organization Hierarchy" />
                    </div>
                    <br>
                    <v-toolbar density="comfortable">
                        <v-spacer></v-spacer>
                        <v-text-field v-model="searchUserCriteria" class="mt-6 mr-4" variant="outlined"
                            density="compact" label="Search" append-icon="mdi-magnify"
                            @click:append="searchUsers"></v-text-field>
                    </v-toolbar>
                    <!-- <v-data-table hide-default-footer density="compact" :headers="headersHierarchy" :items="items"
                        item-key="organizationName">
                    </v-data-table> -->
                </v-container>
            </v-col>
            <v-col cols="0" sm="2"></v-col>
        </v-row>

        <v-dialog v-model="showTermsAndConditions" transition="dialog-bottom-transition" scrollable fullscreen>
            <v-card color="white">
                <v-toolbar>
                    <v-toolbar-title><LanguagePlaceholder default-text="RISE Terms & Conditions" /></v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn icon="mdi-close" @click="showTermsAndConditions = false"></v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-card-text>
                    <RISETermsAndConditions :terms-and-conditions-date="termsAndConditionsDate" :terms-and-conditions-company="termsAndConditionsCompany" />
                </v-card-text>

            </v-card>

        </v-dialog>

        <v-dialog v-model="showSendInvitation" width="650" scrollable>
            <v-card>
                <v-toolbar color="#0d2155">
                    <v-toolbar-title><LanguagePlaceholder default-text="Invite User" /></v-toolbar-title>
                </v-toolbar>
                <v-card-text class="pa-4">
                    <p class="my-2 general-text">
                        Please complete the form below to invite a new user to join RISE. The email address used must
                        match the
                        email domain for the Organization.
                    </p>
                    <v-text-field readonly v-model="invitationData.affinityId" variant="outlined" label="Affinity Id">

                    </v-text-field>
                    <v-text-field readonly v-model="invitationData.partnerName" variant="outlined" label="Partner Name">

                    </v-text-field>
                    <v-text-field v-model="invitationData.firstname" variant="outlined" label="Firstname">

                    </v-text-field>
                    <v-text-field v-model="invitationData.lastname" variant="outlined" label="Lastname">

                    </v-text-field>
                    <v-text-field v-model="invitationData.emailAddress" variant="outlined" label="Email Address">

                    </v-text-field>
                </v-card-text>
                <v-card-actions class="border-t-thin">
                    <v-btn @click="showSendInvitation = false" width="100"><LanguagePlaceholder default-text="Close" /></v-btn>
                    <v-spacer></v-spacer>
                    <v-btn :disabled="!canSubmitInvitation" width="100" @click="submitInvitation" color="#055699"
                        variant="elevated"><LanguagePlaceholder default-text="Submit" /></v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>

</template>

<script setup>
import router from '../router'
import { ref, onMounted, computed } from 'vue'
import { useSystemStore } from '@/stores/system'
import { useUserStore } from '@/stores/user'
import { useRegistrationStore } from '@/stores/registration'


const systemStore = useSystemStore()
const userStore = useUserStore()
const registrationStore = useRegistrationStore()

import LanguagePlaceholder from '@/components/LanguagePlaceholder.vue'
import RISETermsAndConditions from '@/components/RISETermsAndConditions.vue'
import PasswordStrength from '@/components/PasswordStrength.vue'
import { errorMessages } from 'vue/compiler-sfc'


const isOrganizationAdmin = ref(false)
const optionsWindow = ref('detail')
const showTermsAndConditions = ref(false)
const showSendInvitation = ref(false)

const organizationDefaultEmail = ref('')
const searchUserCriteria = ref('')
const newPassword = ref('')
const canSaveNewPassword = ref(false)
const defaultLanguage = ref(1)
const invitationData = ref({})
const invitations = ref([])
const organizationUsers = ref([])

const termsAndConditionsDate = ref('')
const termsAndConditionsCompany = ref('')

const canSubmitInvitation = computed(() => {
    return true
})

onMounted(() => {
    isOrganizationAdmin.value = systemStore.userDetail.isOrganizationAdmin
    defaultLanguage.value = systemStore.userDetail.language
    invitationData.value.affinityId = systemStore.userDetail.affinityId
    invitationData.value.partnerName = systemStore.userDetail.organizationName
    registrationStore.getInvitations().then(result => {
        invitations.value = result.invitations

        return getOrganizationtUsers()
    }).then(result => {
        // extracted to function
        var t = ''
    }).catch(error => {
        console.log(error)
    })

})

const getOrganizationtUsers = () => {
    return new Promise((resolve, reject) => {
        userStore.getOrganizationUsers().then(result => {
            organizationUsers.value = result.organizationUsers
            getTermsAndConditionsInfo()
            resolve()
        }).catch(error => {
            systemStore.showMessage('An error occurred retrieving users.', { color: 'error' })
            reject()
        })
    })
}

const getTermsAndConditionsInfo = () => {
  try {
    if (!organizationUsers.value || organizationUsers.value.length === 0) {
      termsAndConditionsDate.value = '';
      return;
    }

    const userWithMinId = organizationUsers.value.reduce((minObj, currentObj) =>
      currentObj.id < minObj.id ? currentObj : minObj
    );

    termsAndConditionsDate.value = ''
    if (userWithMinId.termsAndConditionsDate) {
        termsAndConditionsDate.value = (new Date(userWithMinId.termsAndConditionsDate)).toLocaleDateString("en-US", {
            year:"numeric",
            month:"short",
            day: 'numeric' 
        });
    }
    termsAndConditionsCompany.value = (systemStore.userDetail.organizationName ?? '') + ' (Affinity Id:' + (systemStore.userDetail.affinityId ?? '') + ')'

  } catch (e) {
    console.error('Error getting terms and conditions date:', e);
    termsAndConditionsDate.value = ''
    termsAndConditionsCompany.value = ''
  }
};

const clickChangeStatus = (o, status) => {
    userStore.toggleUserStatus(o.id, status).then(result => {
        if (result.success === true) {
            getOrganizationtUsers()
        }
    })
}

const submitInvitation = () => {

    registrationStore.sendUserInvitation(invitationData.value.affinityId, invitationData.value.partnerName, invitationData.value.firstname, invitationData.value.lastname, invitationData.value.emailAddress).then(result => {
        if (result.success === true) {
            showSendInvitation.value = false

            registrationStore.getInvitations().then(result => {
                invitations.value = result.invitations
            }).catch(error => {
                console.log(error)
            })
        }
    })

}

const passwordValidated = (validated) => {
    if (validated) {
        canSaveNewPassword.value = true
    }
}

const clickSaveUpdateLanguage = () => {
    systemStore.updateUserLanguage(defaultLanguage.value).then(result => {
        systemStore.showMessage('Userlanguage successullly updated.', { color: 'success' })

        optionsWindow.value = 'detail'
    }).catch(error => {
        systemStore.showMessage('An error occurred dugin update.', { color: 'error' })
    })
}

const languageItems = [
    { title: 'Français', language: 'FRANCAIS' },
    { title: 'Deutsch', language: 'DEUTSCH' },
    { title: 'Español', language: 'ESPANOL' },
    { title: 'Italiano', language: 'ITALIANO' },
    { title: 'English', language: 'ENGLISH' },
    { title: 'Polski', language: 'POLSKI' },
    { title: 'Türkçe', language: 'TURKISH' },
]

// cellProps
const headersOrganizationUsers = [
    { title: 'Email Address', value: 'emailAddress', headerProps: { class: 'header-style' } },
    { title: 'Is Admin', value: 'isAdmin', headerProps: { class: 'header-style' } },
    { title: 'Last Login', value: 'lastLogin', width: '150', headerProps: { class: 'header-style' } },
    { title: 'Opted Into Portal Communications', value: 'optedIntoPortalCommunications', headerProps: { class: 'header-style' } },
    { title: 'User Account Status', value: 'accountStatus', headerProps: { class: 'header-style' } },
    { title: '', value: 'toggleStatus', headerProps: { class: 'header-style' } },
]

const headersInvitations = [
    { title: 'Email Address', value: 'emailAddress', headerProps: { class: 'header-style' } },
    { title: 'Date Invited', value: 'dateInvited', headerProps: { class: 'header-style' } },
    { title: 'Invited By User', value: 'invitedByUser', headerProps: { class: 'header-style' } }
]

const headersHierarchy = [
    { title: 'Organization Name', value: 'organizationName', headerProps: { class: 'header-style' } },
    { title: 'Affinity ID', value: 'affinityID', headerProps: { class: 'header-style' } },
    { title: 'Relationship', value: 'relationship', headerProps: { class: 'header-style' } },
    { title: 'Parent Affinity ID', value: 'parentAffinityID', headerProps: { class: 'header-style' } },
]




const searchUsers = () => {
    var t = searchUserCriteria.value
}

const closeTermsAndConditions = () => {
    showTermsAndConditions.value = false
}

</script>